/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from "react";
import ReferralMoney from "assets/boost/referral-money.webp";
import BoostReferralModal from "./BoostReferralModal";

export const InviteFriends = ({
  referralCode,
  currentProductTerm,
  currentProductTier,
}) => {
  const [showReferralModal, setShowReferralModal] = useState(false);

  return (
    <>
      <div
        className="flex justify-start items-center border border-neutral-200 rounded-md overflow-hidden cursor-pointer"
        style={{ height: 106 }}
        onClick={() => setShowReferralModal(true)}
      >
        <div
          className="flex shrink-0 justify-center items-center bg-success-200"
          style={{ width: 106, height: 106 }}
        >
          <img
            alt=""
            src={ReferralMoney}
            className="w-auto"
            style={{ height: 36 }}
          />
        </div>
        <span className="p-5 bg-white w-full h-full flex flex-col justify-center">
          <p className="text-lg font-bold">
            Invite friends, get $100 cash each
          </p>
          <p className="mt-2 font-medium">Learn more →</p>
        </span>
      </div>
      <BoostReferralModal
        isOpen={showReferralModal}
        closeModal={() => setShowReferralModal(false)}
        referralCode={referralCode}
        currentTerm={currentProductTerm}
        currentTier={currentProductTier}
      />
    </>
  );
};
